import React, { useEffect, useState } from 'react';
import { Row, Col, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import viewIcon from '../../assets/images/icons/viewModalIcon.svg';
import delIcon from '../../assets/images/icons/icon-delete.svg';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import { toast } from 'react-toastify';
import DataTable from 'react-data-table-component';
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
import CommonModal from '../Modals/CommonModal';
import { useAuth } from '../../hooks/useAuth';
import { errorMessageString } from '../../helpers/utils';
import moment from 'moment/moment';
import CustomInput from '../Trips/DateFilterCustom';
import DatePicker from 'react-multi-date-picker';
import Footer from 'react-multi-date-picker/plugins/range_picker_footer';
import useQueryParamsPage from '../../hooks/useQueryParamsPage';

const BookingsList = () => {
    const { user } = useAuth();
    const [bookingTrips, setAllBookingTrips] = useState();
    const [selectedItem, setSelectedItem] = useState();
    const [showDelModal, setShowDelModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [toggleCleared, setToggleCleared] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [buttonDisable, setButtonDisable] = useState(true);
    const [isFilterSelected, setIsFilterSelected] = useState(false);
    const [showBulkDel, setShowBulkDel] = useState(false);
    const [dateFilter, setDateFilter] = useState(false);
    const [value, setValue] = useState([]);
    const { searchParams, page, updateQueryParams, setPage } = useQueryParamsPage();
    const [transitFilter, setTransitFilter] = useState(searchParams.get('transitFilter') || false);
    const [searchValue, setSearchValue] = useState(searchParams.get('search') || '');

    const { getToken } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (user?.role === 'admin' || user?.role === 'commuter') {
            getAllBookingRoutes();
        } else if (user?.role === 'agency') {
            getAllBookingAgencyRoutes();
        }
    }, [value[0], value[1], page, searchParams.get('search'), transitFilter]);

    const getAllBookingRoutes = async (pageSize = 10, pageNo = 0, _search) => {
        setLoading(true);
        const token = getToken();
        if (token)
            new WebApiCalls()
                .getAllBookingRoutes(
                    token,
                    pageSize,
                    page,
                    _search || searchValue,
                    value[0] ? new Date(value[0])?.toDateString() : undefined,
                    value?.[1] ? new Date(value[1])?.toDateString() : undefined,
                    transitFilter
                )
                .then((res) => {
                    if (res?.code === 200) {
                        setAllBookingTrips(res?.data?.bookings);
                        setTotalRecords(res.data?.totalCount);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLoading(false);
                    let errorMessage = errorMessageString(err);

                    toast.error(errorMessage);
                });
    };
    const getAllBookingAgencyRoutes = async (pageSize = 10, pageNo = 0, _search) => {
        setLoading(true);
        const token = getToken();
        if (token)
            new WebApiCalls()
                .getAllBookingAgencyRoutes(
                    token,
                    pageSize,
                    page,
                    _search || searchValue,
                    value[0] ? new Date(value[0])?.toDateString() : undefined,
                    value?.[1] ? new Date(value[1])?.toDateString() : undefined,
                    transitFilter
                )
                .then((res) => {
                    if (res?.code === 200) {
                        setAllBookingTrips(res?.data?.bookings);
                        setTotalRecords(res.data?.totalCount);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLoading(false);
                    let errorMessage = errorMessageString(err);

                    toast.error(errorMessage);
                });
    };

    const handleClose = () => {
        setShowDelModal(false);
        setShowBulkDel(false);
    };

    const handleDelete = async () => {
        const token = getToken();
        if (token && selectedItem?._id) {
            setLoading(true);
            new WebApiCalls()
                .bookingDelete(token, selectedItem?._id)
                .then((res) => {
                    if (res?.code === 200) {
                        toast.success('Booking has been deleted successfully.');
                        getAllBookingRoutes();
                        setLoading(false);
                    } else {
                        toast.error('Oops...! Something went wrong');
                    }
                })
                .catch((err) => {
                    let errorMessage = errorMessageString(err);
                    setLoading(false);

                    toast.error(errorMessage);
                });
        }
    };

    const existingColumns = [
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Route Short Name</span>
                </h6>
            ),
            selector: (row) => row?.route?.short_name || '',
            sortable: true,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Starting Station</span>
                </h6>
            ),
            selector: (row) => row?.starting_station?.name || '',
            sortable: true,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Ending Station</span>
                </h6>
            ),
            selector: (row) => row?.last_station?.name || '',
            // sortable: true,/
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold ">Date</span>
                </h6>
            ),
            selector: (row) => moment(row?.date).format('YYYY-MM-DD'),
            sortable: true,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold ">Transit Type</span>
                </h6>
            ),
            selector: (row) => _.capitalize(row?.transit_type),
            sortable: true,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold ">Total Fare</span>
                </h6>
            ),
            selector: (row) => `$ ${row?.payment?.totalAmount / 100 || 1}`,
            sortable: true,
            center: true
        },

        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Action</span>
                </h6>
            ),
            selector: (row) => (
                <div className="d-flex">
                    <div className="view-detail">
                        <OverlayTrigger delay={{ show: 300, hide: 0 }} placement={'bottom'} overlay={<Tooltip id={`tooltip-bottom`}>View details</Tooltip>}>
                            <div className="edit-detail">
                                <img
                                    width={15}
                                    className="me-3"
                                    src={viewIcon}
                                    alt=""
                                    onClick={() => {
                                        setSelectedItem(row);
                                        updateQueryParams({ page: page, search: searchValue, transitFilter: transitFilter });
                                        navigate('/bookings/booking-details', {
                                            state: {
                                                trip_id: row._id,
                                                trip_details: row
                                            }
                                        });
                                    }}
                                />
                            </div>
                        </OverlayTrigger>
                    </div>

                    <div className="del-detail">
                        <OverlayTrigger delay={{ show: 300, hide: 0 }} placement={'bottom'} overlay={<Tooltip id={`tooltip-bottom`}>Delete</Tooltip>}>
                            <div className="edit-detail">
                                <img
                                    width={15}
                                    className="me-3"
                                    src={delIcon}
                                    alt=""
                                    onClick={() => {
                                        setShowDelModal(true);
                                        setSelectedItem(row);
                                    }}
                                />
                            </div>
                        </OverlayTrigger>
                    </div>
                </div>
            ),
            center: true
        }
    ];
    const columns = [
        ...(user.role === 'agency'
            ? [
                  {
                      name: (
                          <h6 className="text-capitalize mt-2 text-center">
                              <span className="fw-bold">Commuter</span>
                          </h6>
                      ),
                      selector: (row) => row?.commuter?.name || '',
                      sortable: true,
                      center: true
                  }
              ]
            : []),
        ...existingColumns
    ];

    const customStyles = {
        rows: {
            style: {
                textAling: 'center'
            }
        },
        headCells: {
            style: {
                paddingLeft: '8px', // override the cell padding for head cells
                paddingRight: '8px',
                backgroundColor: '#13aa61',
                color: 'white',
                '&:hover': {
                    cursor: 'pointer'
                }
            }
        }
    };

    const handlePageChange = (pageNo) => {
        setPage(pageNo);
        updateQueryParams({ page: pageNo, search: searchValue, transitFilter: transitFilter });
    };
    const handlePerRowsChange = async (pageSize, pageNo) => {
        getAllBookingRoutes(pageSize, pageNo);
        setPageSize(pageSize);
        // setLoading(false);
    };

    const handleRowSelected = React.useCallback((state) => {
        const selectedIds = state.selectedRows.map((item) => {
            return item._id;
        });
        setSelectedRows(selectedIds);
    }, []);

    useEffect(() => {
        if (selectedRows && selectedRows.length > 0) {
            setButtonDisable(false);
        } else {
            setButtonDisable(true);
        }
    }, [selectedRows]);

    const searchDebounce = _.debounce((text) => {
        updateQueryParams({ page: page, search: text, transitFilter: transitFilter });
    }, 2000);

    const deleteBulk = async () => {
        try {
            setLoading(true);
            const token = getToken();
            let obj = {
                _ids: selectedRows
            };
            if (token)
                new WebApiCalls()
                    .deleteBulkBookings(token, obj)
                    .then((res) => {
                        if (res?.code === 200) {
                            getAllBookingRoutes();
                            setLoading(false);
                            toast.success('Bookings are delete successfully.');
                            setToggleCleared(true);
                            setSelectedRows();
                        } else {
                            toast.error('Oops...! Something went wrong');
                        }
                    })
                    .catch((err) => {
                        setLoading(false);
                        let errorMessage = errorMessageString(err);

                        toast.error(errorMessage);
                    });
        } catch (error) {
            console.log('ERROR while updating Bulk', error);
        }
    };
    const handleClearDate = () => {
        setValue([]);
        setTransitFilter('');
        setSearchValue('');
        searchDebounce('');
        updateQueryParams({ page: 1, search: '', transitFilter: '' });
    };

    return (
        <div style={{ padding: '20px' }}>
            <CommonModal handleClose={handleClose} show={showDelModal} handleDelete={handleDelete} text={'Are you sure, you want to delete this Booking?'} />
            <CommonModal handleClose={handleClose} show={showBulkDel} handleDelete={deleteBulk} text={'Are you sure, you want to delete Bookings?'} />

            <Row className="mb-4 mt-1">
                <Col sm={3} md={3} style={{ paddingRight: 0 }}>
                    <input
                        type={'search'}
                        className="search-input-bar"
                        placeholder={'Search here...'}
                        onChange={(e) => {
                            e.preventDefault();
                            searchDebounce(e.target.value);
                            setSearchValue(e.target.value);
                        }}
                        value={searchValue}
                    />
                </Col>
                <Col sm={4} md={4} style={{ paddingLeft: 0 }}>
                    <div className="d-flex gap-10 justify-content-start">
                        <h6 className="text-capitalize mt-2 text-center"></h6>
                        <select
                            value={transitFilter}
                            onChange={(e) => {
                                setTransitFilter(e.target.value);
                                setIsFilterSelected(e.target.value ? true : false);
                                updateQueryParams({ search: searchValue, page: page, transitFilter: e.target.value });
                            }}
                            className="status-selector w-120"
                            aria-label="Default select example"
                            style={{ color: !isFilterSelected ? '#9a9a9a' : '' }}
                        >
                            <option value={''}>Transit Type</option>
                            <option value={'bus'}>Bus</option>
                            <option value={'streetcar'}>Street Car</option>
                            <option value={'subway'}>Subway</option>
                            <option value={'train'}>Train</option>
                        </select>
                        <DatePicker
                            render={<CustomInput />}
                            value={value}
                            onChange={setValue}
                            range
                            numberOfMonths={2}
                            rangeHover
                            plugins={[<Footer position="bottom" />]}
                        />
                        <Button onClick={handleClearDate}>Clear Filter</Button>
                    </div>
                </Col>
                <Col md={5}>
                    <div className="d-flex gap-10 justify-content-end h-100">
                        {!buttonDisable && (
                            <>
                                <Button
                                    className="add-record-btn  justify-content-center w-140"
                                    style={{ background: 'red' }}
                                    onClick={(e) => {
                                        setShowBulkDel(true);
                                        // deleteBulk();
                                        // setActionType('add');
                                        // setShowAddEditModal(true);
                                    }}
                                    disabled={buttonDisable}
                                >
                                    Delete
                                </Button>
                            </>
                        )}
                    </div>
                </Col>
            </Row>
            <DataTable
                columns={columns}
                data={bookingTrips}
                progressPending={bookingTrips && bookingTrips?.length >= 0 ? false : true}
                selectableRows
                pagination
                paginationServer
                paginationTotalRows={totalRecords}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                paginationDefaultPage={parseInt(searchParams.get('page')) || 1}
                responsive
                direction="auto"
                fixedHeaderScrollHeight="300px"
                subHeaderAlign="right"
                subHeaderWrap
                customStyles={customStyles}
                onSelectedRowsChange={handleRowSelected}
                clearSelectedRows={toggleCleared}
            />
        </div>
    );
};
export default BookingsList;
